import { createSlice } from '@reduxjs/toolkit'

const initialState: any = {
  answers: {}, // modified answers
  errors: {},
  initialAnswers: {},
  status: 'idle',
}

export const answersSlice = createSlice({
  name: 'answers',
  initialState,
  reducers: {
    setAnswer: (state, action) => {
      const { questionId, answer } = action.payload

      delete state.errors[questionId]
      state.answers[questionId] = answer
    },
    setError: (state, action) => {
      const { questionId, error } = action.payload

      state.errors[questionId] = error ? error : ''
    },
    setInitialAnswers: (state, action) => {
      state.initialAnswers = action.payload
    },
    setAllAnswers: (state, action) => {
      state.answers = action.payload
    },
    resetAnswers: (state) => {
      state.answers = initialState.answers
    },
    resetInitialAnswers: (state) => {
      state.initialAnswers = initialState.initialAnswers
    },
    resetErrors: (state) => {
      state.errors = initialState.errors
    },
  },
})

export const {
  setAnswer,
  setError,
  setAllAnswers,
  resetAnswers,
  resetErrors,
  setInitialAnswers,
  resetInitialAnswers,
} = answersSlice.actions

export default answersSlice.reducer
